import INITIAL_STATE from './state';

const stateInitializer = () => {
    if (typeof sessionStorage !== 'undefined') {
        return JSON.parse(sessionStorage.getItem('cxpState') ?? JSON.stringify(INITIAL_STATE));
    }
    return INITIAL_STATE;
};

export default { stateInitializer };
